import React from 'react';
import styled from 'styled-components';
import queryString from 'query-string';

import { LinkButton } from '@atlaskit/button/new';

import t from 'modules/i18n/intl';
import config from 'appconfig';

const NotLoggedInWrapper = styled.div`
  padding: 18px 22px;
`;

const Login = ({ children }: any) => {
  const loginParams = queryString.stringify({ continue: window.location.href });
  const loginUrl = `${config.idLoginUrl}?${loginParams}`;

  return (
    <NotLoggedInWrapper>
      <LinkButton href={loginUrl} appearance="primary">
        {t('addon.login')}
      </LinkButton>
      &nbsp;
      {children}
    </NotLoggedInWrapper>
  );
};

export default Login;
